import { Datagrid, DateField, List, SelectInput, TextField } from 'react-admin';
import { AppGlobalAlertsCommandPanel } from './AppGlobalAlertsCommandPanel';

const globalAlertsFilters = [
  <SelectInput
    key="archiveFilter"
    source="archiveFilter"
    label="Archived"
    alwaysOn
    choices={[
      { id: 'hidden', name: 'Hidden' },
      { id: 'visible', name: 'Visible' },
      { id: 'only', name: 'Only' },
    ]}
    format={(value: string | undefined) => value ?? 'visible'}
  />,
];

export const AppGlobalAlertsList = () => (
  <List
    resource="appGlobalAlerts"
    sort={{ field: 'createdAt', order: 'DESC' }}
    filterDefaultValues={{ archiveFilter: 'visible' }}
    filters={globalAlertsFilters}
    empty={false}
  >
    <Datagrid
      bulkActionButtons={false}
      expand={AppGlobalAlertsCommandPanel}
    >
      <TextField source="id" />
      <TextField source="title" />
      <DateField source="createdAt" showTime />
      <DateField source="archivedAt" showTime />
    </Datagrid>
  </List>
);
